var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 35)",
    fill: "#F7801A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 19.6699C17.8704 19.6699 16.1304 17.9399 16.1304 15.7999C16.1304 13.6599 17.8704 11.9399 20.0004 11.9399C22.1304 11.9399 23.8704 13.6699 23.8704 15.8099C23.8704 17.9499 22.1304 19.6699 20.0004 19.6699ZM20.0004 13.4399C18.7004 13.4399 17.6304 14.4999 17.6304 15.8099C17.6304 17.1199 18.6904 18.1799 20.0004 18.1799C21.3104 18.1799 22.3704 17.1199 22.3704 15.8099C22.3704 14.4999 21.3004 13.4399 20.0004 13.4399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 28.26C18.5197 28.26 17.0297 27.7 15.8697 26.59C12.9197 23.75 9.65969 19.22 10.8897 13.83C11.9997 8.94 16.2697 6.75 19.9997 6.75C19.9997 6.75 19.9997 6.75 20.0097 6.75C23.7397 6.75 28.0097 8.94 29.1197 13.84C30.3397 19.23 27.0797 23.75 24.1297 26.59C22.9697 27.7 21.4797 28.26 19.9997 28.26ZM19.9997 8.25C17.0897 8.25 13.3497 9.8 12.3597 14.16C11.2797 18.87 14.2397 22.93 16.9197 25.5C18.6497 27.17 21.3597 27.17 23.0897 25.5C25.7597 22.93 28.7197 18.87 27.6597 14.16C26.6597 9.8 22.9097 8.25 19.9997 8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.55ad17645eb9cb8477ab089ae7776748.svg";
export { ForwardRef as ReactComponent };